import {
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_INIT,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_SUCCESS,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_FAILURE,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_INIT,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_FAILURE,
  CREATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  CREATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  CREATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  DELETE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  DELETE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  DELETE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_INIT,
  ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
  ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
  RESET_MODAL,
  RESET_ACCOUNT_WORKING_SHIFT_GROUP,
  RESET_MODAL_FILE,
} from './types';
import API from './api';

/* Actions Creators */

export function resetModalWorkingShiftGroup() {
  return {
    type: RESET_MODAL
  };
}

export function resetAccountWorkingShiftGroup() {
  return {
    type: RESET_ACCOUNT_WORKING_SHIFT_GROUP
  };
}

/* Account WorkingShiftGroup */

function fetchApiSuccess(data) {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_INIT
  };
}

export function fetchAccountWorkingShiftGroupApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Account WorkingShiftGroup no loading */

function fetchApiNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_SUCCESS,
    payload: data,
    concat: concat
  };
}

function fetchApiNoLoadingFailure(error) {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_INIT
  };
}

export function fetchAccountWorkingShiftGroupNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* WorkingShiftGroup Create (Async) */

function createApiSuccess(data) {
  return {
    type: CREATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
    payload: data
  };
}

function createApiFailure(error) {
  return {
    type: CREATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
    errorupdate: error
  };
}

function createApiInit() {
  return {
    type: CREATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT
  };
}

export function handleCreateWorkingShiftGroup(data) {
  return async dispatch => {
    dispatch(createApiInit());
    try {
      const resp = await API.data.handleCreateWorkingShiftGroup(data);
      return dispatch(createApiSuccess(resp));
    } catch (error) {
      return dispatch(createApiFailure(error));
    }
  };
}


/* WorkingShiftGroup Update (Async) */

function updateApiSuccess(data) {
  return {
    type: UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
    payload: data
  };
}

function updateApiFailure(error) {
  return {
    type: UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
    errorupdate: error
  };
}

function updateApiInit() {
  return {
    type: UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT
  };
}

export function handleUpdateWorkingShiftGroup(data) {
  return async dispatch => {
    dispatch(updateApiInit());
    try {
      const resp = await API.data.handleUpdateWorkingShiftGroup(data);
      return dispatch(updateApiSuccess(resp));
    } catch (error) {
      return dispatch(updateApiFailure(error));
    }
  };
}

/* WorkingShiftGroup Delete (Async) */

function deleteApiSuccess(data) {
  return {
    type: DELETE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
    payload: data
  };
}

function deleteApiFailure(error) {
  return {
    type: DELETE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
    errordelete: error
  };
}

function deleteApiInit() {
  return {
    type: DELETE_ACCOUNT_WORKING_SHIFT_GROUP_INIT
  };
}

export function handleDeleteWorkingShiftGroup(data) {
  return async dispatch => {
    dispatch(deleteApiInit());
    try {
      const resp = await API.data.handleDeleteWorkingShiftGroup(data);
      return dispatch(deleteApiSuccess(resp));
    } catch (error) {
      return dispatch(deleteApiFailure(error));
    }
  };
}

/* Active WorkingShiftGroup (Async) */

function activeApiSuccess(data) {
  return {
    type: ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS,
    payload: data
  };
}

function activeApiFailure(error) {
  return {
    type: ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE,
    errordelete: error
  };
}

function activeApiInit() {
  return {
    type: ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_INIT
  };
}

export function handleActiveWorkingShiftGroup(data) {
  return async dispatch => {
    dispatch(activeApiInit());
    try {
      const resp = await API.data.handleActiveWorkingShiftGroup(data);
      return dispatch(activeApiSuccess(resp));
    } catch (error) {
      return dispatch(activeApiFailure(error));
    }
  };
}

/* Account WorkingShiftGroup COUNT */

function fetchApiCountSuccess(data) {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_SUCCESS,
    payload: data
  };
}

function fetchApiCountFailure(error) {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_FAILURE,
    payload: error
  };
}

function fetchApiCountInit() {
  return {
    type: FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_INIT
  };
}

export function fetchAccountWorkingShiftGroupCountApi(obj) {
  return async dispatch => {
    dispatch(fetchApiCountInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchApiCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiCountFailure(error));
    }
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/account_working_shift_group/index.js